import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Group } from '@calendly/ui/components/menu';
import { Control, Option, Options, Select } from '@calendly/ui/components/select';
import { LabelText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
import { getAvailabilityFromRule } from 'components/event_type_edit';
import { useEventType } from 'features/event_type_provider';
import { useTrackAvailabilityInteraction } from 'hooks/analytics_events/use_track_availability_interaction';
import { getScheduleName } from './helpers';
import { useActiveSchedule } from './use_active_schedule';
const customOptionCss = "c1uylteu";
const CustomOption = forwardRef((props, ref) => <Option ref={ref} {...props} className={classNames(customOptionCss, props.className)} />);
export const SchedulesDropdown = ({
  formPath
}) => {
  const eventType = useEventType();
  const [{
    value
  }, _, {
    setValue
  }] = useFormField({
    name: formPath
  });
  const trackETEAvailabilityInteraction = useTrackAvailabilityInteraction({
    eventType,
    location: 'et_editor'
  });
  const {
    activeSchedule,
    activeScheduleName
  } = useActiveSchedule({
    formPath
  });
  const {
    activeAvailabilityRuleId,
    usingCustomHours,
    customRuleId,
    ownerAvailabilityRules
  } = value;
  const primaryRuleId = ownerAvailabilityRules?.primaryRuleId || ownerAvailabilityRules?.primary_rule_id;
  const memberSchedules = ownerAvailabilityRules?.rules;
  const handleScheduleChange = useCallback(selectedScheduleId => {
    if (selectedScheduleId === 'custom') {
      trackETEAvailabilityInteraction({
        action: 'customize_schedule_for_this_event_type_only'
      });
      setValue({
        ...value,
        ...getAvailabilityFromRule(activeSchedule),
        usingCustomHours: true,
        usingSecondarySchedule: false,
        activeAvailabilityRuleId: customRuleId
      });
    } else {
      const selectedSchedule = memberSchedules.find(({
        id
      }) => id === selectedScheduleId);
      const isPrimaryRule = primaryRuleId === selectedSchedule.id;
      if (isPrimaryRule) trackETEAvailabilityInteraction({
        action: 'reset_to_default_schedule'
      });
      setValue({
        ...value,
        usingCustomHours: false,
        usingSecondarySchedule: true,
        activeAvailabilityRuleId: selectedSchedule.id,
        ...getAvailabilityFromRule(selectedSchedule)
      });
    }
  }, [activeSchedule, customRuleId, memberSchedules, primaryRuleId, setValue, trackETEAvailabilityInteraction, value]);
  if (!(ownerAvailabilityRules && memberSchedules)) {
    return null;
  }
  return <Select onChange={handleScheduleChange} value={usingCustomHours ? 'custom' : activeAvailabilityRuleId} inline name={`${formPath}.scheduleType`}>
      <Control wrap variant="minimal" aria-label={I18n.t('publisher.event_type_editor.sections.availability.schedule.title')}>
        <LabelText size="large">{activeScheduleName}</LabelText>
      </Control>
      <Options>
        <Group>
          {memberSchedules.map(({
          id,
          name
        }) => <CustomOption key={id} value={id}>
              {getScheduleName(id === primaryRuleId, name)}
            </CustomOption>)}
        </Group>
        <Group>
          <CustomOption value="custom">
            {I18n.t('publisher.event_type_editor.sections.availability.schedule.actions.custom_schedule_label')}
          </CustomOption>
        </Group>
      </Options>
    </Select>;
};

require("./schedules_dropdown.wyw-in-js.css!=!../../../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./schedules_dropdown.js");